import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
} from '@mui/material';
import moment from 'moment';
import Footer from '../navbar/Footer';


const cahiersData = [
  {
    title: "LES CAHIERS DE L’ISTEEBU / Volume 2, N°01",
    link: "/documents/Cahiers/Recueil-des-cahiers-de-lISTEEBU-edition-2016-.pdf",
    image: 'assets/cahiers/recueil_cahiers_2016_v2.PNG', 
    description: "L'analyse des thématiques à partir des données d’enquêtes réalisées au sein du Système Statistique National",
    date: "2016-12-31"
  },
  {
    title: "LES CAHIERS DE L'ISTEEBU/ Volume 1,N°01 ",
    link: "/documents/Cahiers/Recueil-des-cahiers-de-lISTEEBU-Ǹdition-2015-1.pdf",
    image: 'assets/cahiers/recueil_cahiers_2016_v1.PNG', 
    description: "L'analyse des thématiques à partir des données d'enquêtes réalisées au sein du Système Statistique National ",
    date: "2016-06-30"
  },
  
];

function CahiersINSBU() {
  const [visibleCount, setVisibleCount] = useState(2);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredCahiers, setFilteredCahiers] = useState(cahiersData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredCahiers(cahiersData);
    } else {
      const filtered = cahiersData.filter((cahier) => {
        const cahierYear = new Date(cahier.date).getFullYear();
        return cahierYear === parseInt(year);
      });
      setFilteredCahiers(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      secondary: {
        main: '#673AB7',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h6: {
        fontWeight: '500',
        fontSize: '1rem',
        textTransform: 'none',
        color: '#3B3F54'
      },
      body2: {
        fontSize: 14,
        letterSpacing: 0.25,
        color: '#6B778C',
      },
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: '500',
            padding: '10px 20px',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
            '&:hover': {
              transform: 'scale(1.05)',
              boxShadow: '0px 12px 20px rgba(0, 0, 0, 0.15)',
            },
            borderRadius: '8px',
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          h6: {
            fontWeight: '500',
            fontSize: '1rem'
          },
          h4: {
            fontWeight: '600',
          },
        },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            marginBottom: '16px',
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Cahiers de l’INSBU
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Les Cahiers de l’INSBU sont une collection de réflexions et d'analyses thématiques, riches en insights, dérivées des données d’enquêtes menées au sein du Système Statistique National (SSN). Conçus pour éclairer les décisions politiques et informées, ces cahiers mettent en lumière les tendances et les dynamiques socio-économiques du Burundi. Chaque édition propose une analyse approfondie des données, contribuant ainsi à une meilleure compréhension des réalités du pays et favorisant un dialogue constructif sur des thèmes cruciaux.
          </Typography>
          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionnez par l'année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionnez par l'année de publication"
            >
              <MenuItem value="Tous">Tous les cahiers</MenuItem>
              {[...new Set(cahiersData.map((cahier) => new Date(cahier.date).getFullYear()))]
                .sort()
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          {/* Affichage des Cahiers */}
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredCahiers.slice(0, visibleCount).map((cahier, index) => (
              <Grid item xs={12} sm={6} md={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                        <CardMedia
                              component="img"
                              sx={{ width: 61, height: 100, m: 2,cursor: 'pointer' }}
                              image={cahier.image}
                              alt={cahier.title}
                              onClick={() => window.open(cahier.link, '_blank')} 
                          />                      
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold',color: 'green', marginBottom: '10px', cursor: 'pointer' }} onClick={() => window.open(cahier.link, '_blank')}>
                      {<DownloadIcon />}{cahier.title}
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {cahier.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(cahier.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredCahiers.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Cahiers
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default CahiersINSBU;